import React, { ReactNode } from "react";

interface Props {
  title: ReactNode;
  left: ReactNode;
  right: ReactNode;
}

export default function (props: Props) {
  return (
    <>
      <div className="row mt-5">
        <div className="col-12">{props.title}</div>
      </div>
      <div className="row mt-5">
        <div className="d-flex col-12 col-xl-6" style={{ flex: 1 }}>
          {props.left}
        </div>
        <div className="d-flex col-12 col-xl-6 mt-2 mt-xl-0">{props.right}</div>
      </div>
    </>
  );
}
